import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import AppLayout from 'containers/Layouts/AppLayout/AppLayout';

var ContainerErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerErrorBoundary, _React$Component);

  var _super = _createSuper(ContainerErrorBoundary);

  function ContainerErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ContainerErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(ContainerErrorBoundary, [{
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/React.createElement(AppLayout, null, /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            height: '100%'
          }
        }, /*#__PURE__*/React.createElement("h1", null, "Something went wrong!"), /*#__PURE__*/React.createElement("p", {
          style: {
            textAlign: 'center'
          }
        }, "We cannot display this page at the moment. We have been notified of this issue and will get it back up and running soon!"), /*#__PURE__*/React.createElement("p", {
          style: {
            textAlign: 'center'
          }
        }, "Thanks for your patience!")));
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      console.error('Caught Error at ContainerErrorBoundary', error);
      return {
        hasError: true
      };
    }
  }]);

  return ContainerErrorBoundary;
}(React.Component);

export { ContainerErrorBoundary as default };